import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

const DEFAULT_SIZE = 28;

function AlertsBadge({ text, size, iconColor, textColor }) {
  return (
    <Styled.AlertsBadgeContainer size={size}>
      <Styled.AlertsBadgeIcon height={size} fill={iconColor} />
      <Styled.AlertsBadgeText
        size={size}
        defaultSize={DEFAULT_SIZE}
        textLength={text.length}
        textColor={textColor}
      >
        {text}
      </Styled.AlertsBadgeText>
    </Styled.AlertsBadgeContainer>
  );
}

AlertsBadge.propTypes = {
  /** Text that is displayed the center of the badge */
  text: PropTypes.string,
  /** Size of the badge in pixels, text and icon are scaled based on this */
  size: PropTypes.number,
  /** Fill color of icon element, accepts an valid css color value */
  iconColor: PropTypes.string,
  /** Color of text inside the badge */
  textColor: PropTypes.string,
};

AlertsBadge.defaultProps = {
  text: '!',
  size: DEFAULT_SIZE,
  iconColor: null,
  textColor: null,
};

export default AlertsBadge;
